import { anyShortCircuit } from "./util/func";

/**
 * Whitelists requests that should be cached.
 * Tedious, but will prevent stupid problems
 * @type {RegExp[]}
 */
export const cacheWhiteList = [];

/**
 * Simple cache for GET Request.
 */
export const SimpleCache = class SimpleCache {
  constructor() {
    this.map = {};
  }

  /**
   * Gets a key, if there's no match, set it then return.
   * @param key
   * @param fallback
   * @returns {Promise<*>}
   */
  async get(key, fallback) {
    if (!this.test(key)) return await fallback();
    return this.map[key] || this.set(key, await fallback());
  }

  /**
   * Sets a key, return identity
   * @param key
   * @param val
   * @returns {*}
   */
  set(key, val) {
    this.map[key] = val;
    return val;
  }

  /**
   * Expires a key
   * @param key
   */
  expire(key) {
    this.map[key] && delete this.map[key];
  }

  /**
   * Tests a key against the whitelist
   * @param key
   * @returns {boolean}
   */
  test(key) {
    return anyShortCircuit(cacheWhiteList, reg => reg.test(key));
  }
};
